function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-761-247H679V823H-761z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 3h70v60H1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 45.63h5.867c5.565-1.23 8.602-1.765 9.111-1.606 1.416.44.587 1.244 5.564 1.605 3.317.242 13.137.242 29.458 0V40l-2.29-4.188c.505-.577.505-1.18 0-1.812-.756-.947-3.692-3.65-4.21-4-.345-.233-1.345-.233-3 0l-10.655-6.966a10 10 0 00-5.146-1.625L25.686 21l-4.807 7.35H17.5L16.149 35c-1.567 1.287-2.45 2.287-2.649 3-.199.713-.199 3.256 0 7.63z",
  stroke: "#944923",
  fill: "#E72B2B",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5 28.5H21l4.5-7.495h-3.577c-2.615-.053-3.923.32-3.923 1.117 0 1.198 1.803.999 1.803 1.78 0 .52-.767 2.053-2.303 4.598z",
  stroke: "#944923",
  fill: "#C31616",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 29.336L52 31l-9.215-6.064a10 10 0 00-5.035-1.635c-5.9-.273-9.199-.325-9.898-.156-.801.193-2.085 2.257-3.852 6.191z",
  stroke: "#944923",
  fill: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16 38)",
  stroke: "#944923"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#F9D8A0",
  cx: 7,
  cy: 7,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 7,
  cy: 7,
  r: 4
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47 38)",
  stroke: "#944923"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#F9D8A0",
  cx: 7,
  cy: 7,
  r: 7
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 7,
  cy: 7,
  r: 4
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F9D8A0",
  d: "M45.073 27.054l-1.03 2.965 6.088.34z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.475 30.5h5.053M7.475 33.5H14.5M7 36.5h4.795",
  stroke: "#260119",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.001 32.847c0 .61 3.116 4.072 3.878 2.92.762-1.152-2.294-3.767-3.12-3.767-.827 0-.758.237-.758.847z",
  fill: "#F2E5BD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.02 33.092V34a2 2 0 002 2h27.26a1 1 0 00.818-1.575c-.78-1.11-1.646-1.752-2.598-1.925-1.281-.233-9.745-.702-25.39-1.406a2 2 0 00-2.09 1.998z",
  fillOpacity: 0.353,
  fill: "#FFF"
}));

function SvgInWay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 70 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgInWay;